export default "__VITE_ASSET__CE3$VzQ3__"